import { all, call, put, takeLatest } from "redux-saga/effects"
import { GET_EMPLOYEE_LEADERBOARD } from "./types"
import { getEmployeeLeaderBoardFailure, getEmployeeLeaderBoardSuccess,setTotalPoints } from "./actions"
import UXR from '../../../../utils/XHR'
import { BASE_URL } from "../../../../config/app"

// types
import { QUIZ, ATTEMPT_QUIZ, QUIZ_FINISHED } from "./types"
import {
  setIndex,
  getQuizSuccess,
  getQuizFailure,
  attemptQuizSuccess,
  attemptQuizFailure
} from "./actions"



async function getQuizAPI(data,meeting_id) {
  const token = await sessionStorage.getItem("token")
  const URL = `${BASE_URL}/api/v1/questions/?video_id=${data}&meeting_id=${meeting_id}`
  const options = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Token ${token}`
    },
    method: "GET"
  }

  return UXR(URL, options)
}

function* GetQuiz({ data ,meeting_id}) {
  try {
    const res = yield call(getQuizAPI, data,meeting_id)
    yield put(getQuizSuccess(res.data))
  } catch (e) {
    
    //mapErrors(e)
    yield put(getQuizFailure(e.response))
  }
}

async function attemptQuizAPI(data) {
  const token = await sessionStorage.getItem("token")
  const URL = `${BASE_URL}/api/v1/answers/`
  const options = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Token ${token}`
    },
    method: "POST",
    data
  }

  return UXR(URL, options)
}

function* AttemptQuiz({ data, len, nextIndex}) {
  try {
    const res = yield call(attemptQuizAPI, data,len)
    yield put(attemptQuizSuccess(res.data))
    // Dispatch total points if available
    if (res?.data?.total_points !== undefined) {
      yield put(setTotalPoints(res.data.total_points));
    }
    if (nextIndex == -1) {
      yield put(setIndex({index: len-1,isFinished:true}))
    }else{
      yield put(setIndex({index: nextIndex,isFinished:false}))
    }
  } catch (e) {
    //mapErrors(e)
    yield put(attemptQuizFailure(e.response))
  }
}

async function finishQuizAPI(data) {
  const token = await sessionStorage.getItem("token")
  const URL = `${BASE_URL}/api/v1/quiz-completed/`
  const options = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Token ${token}`
    },
    method: "POST",
    data: data
  }

  return UXR(URL, options)
}

function* FinishQuiz({ data }) {
  try {
    const res = yield call(finishQuizAPI, data)
  } catch (e) {
    
    //mapErrors(e)
  }
}
export default all([
  takeLatest(QUIZ, GetQuiz),
  takeLatest(QUIZ_FINISHED, FinishQuiz),
  takeLatest(ATTEMPT_QUIZ, AttemptQuiz)
])
